
import React, { useState , useContext} from "react";
import {  changeDateFotmate, currencySymbol , loggedInUserDetails , loggedInCustomerDetails } from '../../functions/Function';
import  { WebContext }  from "../../Webroute";
const  Profile = (props) => {
    const WebData = useContext(WebContext);
  return (
    <>
                           
                            <div className="account-right-content-shdow">
                                <h5 className="account-tab-heading">
                                    Profile

                                </h5>
                                <ul className="account-profile-contentent">
                                    {/* <li>
                                        <div className="profile-avatar">
                                            <img src="images/avatar.png" alt="" />
                                        </div>
                                        <div className="profile-avatar-content">
                                            <div className="profile-first-h">
                                                NAME
                                            </div>
                                            <div className="profile-scond-h">
                                                {loggedInCustomerDetails('name')}
                                            </div>
                                        </div>
                                    </li> */}

                                    <li>
                                        <div className="profile-avatar profile-icon">
                                            <i className="fa-solid fa-circle-user"></i>
                                        </div>
                                        <div className="profile-avatar-content">
                                            <div className="profile-first-h">
                                                NAME
                                            </div>
                                            <div className="profile-scond-h">
                                            {loggedInCustomerDetails('name')}
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="profile-avatar profile-icon">
                                            <i className="fa-solid fa-envelope"></i>
                                        </div>
                                        <div className="profile-avatar-content">
                                            <div className="profile-first-h">
                                                EMAIL
                                            </div>
                                            <div className="profile-scond-h">
                                            {loggedInCustomerDetails('email')}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="profile-avatar profile-icon">
                                            <i className="fa-solid fa-phone"></i>
                                        </div>
                                        <div className="profile-avatar-content">
                                            <div className="profile-first-h">
                                                PHONE
                                            </div>
                                            <div className="profile-scond-h">
                                            {WebData.customer.phone == '' ?
                                                'No Added'
                                            : 
                                                loggedInCustomerDetails('phone')
                                            }
                                            
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
    </>

  );
}

export default Profile;
